








































































































































































































































import { Vue, Component, Prop, Mixins } from "vue-property-decorator";
import FileUploader from "@/components/FileUploader.vue";
import Page from "@/views/Page.vue";
import ICompany from "../../models/interfaces/ICompany";
import CompaniesMixin from "../../mixins/http/CompaniesMixin";
import { RegisterHttp } from "../../utils/Decorators";
import GeneralSettingsSelect from "@/components/GeneralSettings/Select.vue";
import GeneralSettingsMultiSelect from "@/components/GeneralSettings/MultiSelect.vue";
import { Company } from "../../models";
import { showToast } from "../../utils/RailsRoutes";
import { CompanyPayload } from "../../models/Company";
import RequestData from "@/store/types/RequestData";
@Component({
  components: {
    Page,
    FileUploader,
    GeneralSettingsSelect,
    GeneralSettingsMultiSelect,
  },
})
export default class CompanyCreate extends Mixins(CompaniesMixin) {
  private company: CompanyPayload = new CompanyPayload();

  static readonly createCompanyTag = "create_company_tag";
  @RegisterHttp(CompanyCreate.createCompanyTag)
  createCompanyRequest: RequestData;

  private logo = null;
  private emailError = false;
  private emailRegExp =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  get loading() {
    return this.createCompanyRequest?.loading;
  }

  get valid() {
    return (
      this.company.name &&
      this.company.businessName &&
      this.company.vatNumber &&
      this.company.currencyId &&
      this.company.languageId &&
      this.company.countryIds?.length &&
      this.company.address &&
      this.company.email &&
      this.emailValid
    );
  }

  get emailValid() {
    return this.emailRegExp.test(this.company.email);
  }

  createPayload() {
    let payload = new FormData();
    for (const id of this.company.countryIds) {
      payload.append("country_ids[]", id);
    }
    delete this.company.countryIds;
    for (const key in this.company) {
      if (this.company[key] !== null && this.company[key] !== undefined) {
        payload.append(key, this.company[key]);
      }
    }
    if (this.logo) {
      payload.append("logo", this.logo.file);
    }
    return payload;
  }

  onCountriesChanged(data) {
    const key = "countryIds";
    this.company[key] = data[key];
  }

  onGeneralSettingChanged(key: string, value) {
    this.company[key] = value;
  }

  openFiles() {
    const file = (this.$refs.upload as any).openFileBrowser();
  }

  onCreate() {
    const payload = this.createPayload();
    this.createCompany(payload, CompanyCreate.createCompanyTag).then(
      (resp) => {
        showToast(`Company ${resp.name} created successfully`);
        this.$router.back();
      },
      (err) => {
        const message = err?.response?.data?.message || err.message;
        showToast(`An occurred while creating Company. ${message}`, {
          type: "error",
        });
      }
    );
  }
}
